export const STRIPE_PRICING_TABLE_SCRIPT_URL: string =
  // https://js.stripe.com/v3/pricing-table.js
  process.env.REACT_APP_STRIPE_PRICING_TABLE_SCRIPT_URL ?? "not-supplied";

export const STRIPE_CUSTOMER_PORTAL_URL: string =
  process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_URL ?? "not-supplied";
